import Vue from 'vue'

import VueRouter from 'vue-router'
import Home from '@/components/Home'
import Game from '@/components/Game'
import Illust from '@/components/Illust'
import Music from '@/components/Music'
import Novel from '@/components/Novel'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/game",
    name: "GameList",
    component: Game
  },
  {
    path: "/game/:id",
    name: "GameDetail",
    component: Game,
    props: true
  },
  {
    path: "/illust",
    name: "Illust",
    component: Illust,
  },
  {
    path: "/illust/:id",
    name: "IllustDetail",
    component: Illust,
    props: true
  },
  {
    path: "/music",
    name: "Music",
    component: Music,
  },
  {
    path: "/music/:id",
    name: "MusicDetail",
    component: Music,
    props: true
  },
  {
    path: "/novel",
    name: "Novel",
    component: Novel,
  },
  {
    path: "/novel/:id",
    name: "NovelDetail",
    component: Novel,
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  base: "/qfes", // 本番環境でｙはこっち
  routes,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
